import React, { FC } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Box } from "@mui/material";

import { TextInput } from "../../../../common/form-controls";
import { ADD_MODE, EntityFormSubtitle } from "../../../../common/entity-form";
import { CompensationProcedureDetailed } from "@/types/compensation-procedures";
import { ErrorDetails } from "types/common/responses/responses-types";

type InputProps = {
    value: string;
    setValue: (value: string) => void;
    error: ErrorDetails | null;
    disabled?: boolean;
};

const CompensationProcedureIdInput: FC<InputProps> = ({ value, setValue, disabled, error }) => {
    const intl = useIntl();

    return (
        <TextInput
            label={intl.formatMessage({ id: "compensation-procedure-form-page-compensation-procedure.input-compensation-procedure-id" })}
            value={value}
            onChange={(event) => setValue(event.target.value)}
            disabled={disabled}
            error={error?.value === value}
            errorMessage={error?.message}
        />
    );
};

const CompensationProcedureDescriptionInput: FC<InputProps> = ({ value, setValue, disabled, error }) => {
    const intl = useIntl();

    return (
        <TextInput
            multiline
            rows={3}
            label={intl.formatMessage({ id: "compensation-procedure-form-page-compensation-procedure.input-description" })}
            value={value}
            onChange={(event) => setValue(event.target.value)}
            disabled={disabled}
            error={error?.value === value}
            errorMessage={error?.message}
        />
    );
};

type CompensationProcedureFormPageCompensationProcedureProps = {
    form: CompensationProcedureDetailed;
    setForm: (value: CompensationProcedureDetailed) => void;
    disabled: boolean;
    mode: string;
    validationErrors: Record<string, ErrorDetails> | null;
};

const CompensationProcedureFormPageCompensationProcedure: FC<CompensationProcedureFormPageCompensationProcedureProps> = ({
    form,
    setForm,
    disabled,
    mode,
    validationErrors,
}) => {
    const setId = (value) => setForm({ ...form, id: value });
    const setDescription = (value) => setForm({ ...form, description: value });

    const idDisabled = mode !== ADD_MODE;

    return (
        <>
            <Box className="compensation-procedure-form-page-compensation-procedure-inputs">
                <EntityFormSubtitle>
                    <FormattedMessage id="compensation-procedure-form-page-compensation-procedure.title" />
                </EntityFormSubtitle>
                <CompensationProcedureIdInput
                    value={form.id}
                    setValue={setId}
                    disabled={idDisabled}
                    error={validationErrors && validationErrors["compensation_procedure_id"]}
                />

                <CompensationProcedureDescriptionInput
                    value={form.description}
                    setValue={setDescription}
                    disabled={disabled}
                    error={validationErrors && validationErrors["description"]}
                />
            </Box>
        </>
    );
};

export default CompensationProcedureFormPageCompensationProcedure;
